/**
 * Best-effort email of the signed-in admin, read from the dev bearer token's
 * payload. Cookie sessions carry no readable token, so this can be null; the
 * API's `mine` flag on a review is the other way we recognise the admin's own.
 */
export function currentAdminEmail(): string | null {
  try {
    const token = sessionStorage.getItem("recruit_ai_token");
    if (!token) return null;
    const payload = token.split(".")[1];
    if (!payload) return null;
    const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    const email = (JSON.parse(json) as { email?: unknown }).email;
    return typeof email === "string" ? email.toLowerCase() : null;
  } catch {
    return null;
  }
}
